import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, Input } from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import {
	applicationLinkEndpointInformation,
	applicationLinkEndpointKind,
} from '../../interfaces/applicationlinkendpointinformation.interface';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';

@Component({
	selector: 'detailed-grid-functionapps',
	templateUrl: './detailed-grid.component.html',
	styleUrls: ['./detailed-grid.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [DxiColumnModule, DxDataGridModule]
})
export class DetailedGridComponent {
	@Input() applicationLinkEndpointInformation: applicationLinkEndpointInformation[];

	endpointKindEnums: { [key: number]: string } = {
		[applicationLinkEndpointKind.Undefined]: 'Undefined',
		[applicationLinkEndpointKind.PostInvoices]: 'Post Invoices',
		[applicationLinkEndpointKind.GetInvoices]: 'Get Invoices',
		[applicationLinkEndpointKind.PostAccounts]: 'Post Accounts',
		[applicationLinkEndpointKind.GetAccounts]: 'Get Accounts',
		[applicationLinkEndpointKind.WriteWebserviceDate]: 'Write WebServiceDate',
		[applicationLinkEndpointKind.GetInvoiceIds]: 'Get Invoice Ids',
	};

	constructor() {}

	getKindName(kind: number) {
		return this.endpointKindEnums[kind];
	}
}
